/* eslint-disable max-len */
import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';

import {colors, notWebMediaQuery} from './../../styles';

import PlayIcon from './../../assets/play_icon.png';

import {contentUrlSolver} from './../../helpers';

const Container = styled.div`
    cursor: pointer;
    position: relative;
    display: flex;
    width: auto;
    height: auto;
    padding-bottom: calc(16 / 9 * 100%);
    overflow: hidden;
    transition: transform 0.35s cubic-bezier(0.68, -0.51, 0.22, 1.68);

    &:hover {
        & > button:first-of-type {
            opacity: 1;
        }

        & > div:first-of-type {
            opacity: 0.35;
        }
    }
`;

const Background = styled.div`
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    pointer-events: none;

    background: url(${props => props.background});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50% 50%;
    border-radius: ${props => (props.horizontal ? '2px' : '14px')};
    flex: 0.45;
    background-color: #211921;
    transition: 0.15s all ease-in-out;
    overflow: hidden;
    ${props =>
        props.horizontal &&
        `
        max-width: 260px;
    `}
`;

const PlayButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    z-index: 1;
    height: 45px;
    width: 45px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 0px;
    border-radius: 100%;
    background: rgb(255, 255, 255);
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
    opacity: 0;
    pointer-events: none;

    svg rect {
        fill: ${colors.cartoonBlack};
    }

    ${notWebMediaQuery} {
        display: none;
    }
`;

const MoviePoster = ({data, action, ...props}) => {
    const config = useSelector(state => state.config);

    const handleClick = e => {
        if (action) {
            action();
        }
    };

    return (
        <Container title={data.title} onClick={handleClick}>
            <Background
                background={contentUrlSolver(
                    config,
                    data.image,
                    'POSTER',
                    'png',
                )}
            />

            <PlayButton title={data.title}>
                <img src={PlayIcon} alt="Play" title={data.title} />
            </PlayButton>
        </Container>
    );
};

export default MoviePoster;
